"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = void 0;
const handled_error_1 = require("./handled.error");
class ApiError extends handled_error_1.HandledError {
    constructor(message, code, data) {
        super(message);
        this.message = message;
        this.code = code;
        this.data = data;
    }
    get body() {
        return {
            message: this.message,
            code: this.code,
            data: this.data,
        };
    }
}
exports.ApiError = ApiError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBpLmVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FwaS5lcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtREFBOEM7QUFFOUMsTUFBYSxRQUE4QixTQUFRLDRCQUFZO0lBQzdELFlBQ2tCLE9BQWUsRUFDZixJQUFPLEVBQ1AsSUFBTztRQUV2QixLQUFLLENBQUMsT0FBTyxDQUFDLENBQUE7UUFKRSxZQUFPLEdBQVAsT0FBTyxDQUFRO1FBQ2YsU0FBSSxHQUFKLElBQUksQ0FBRztRQUNQLFNBQUksR0FBSixJQUFJLENBQUc7SUFHekIsQ0FBQztJQUVELElBQUksSUFBSTtRQUNOLE9BQU87WUFDTCxPQUFPLEVBQUUsSUFBSSxDQUFDLE9BQU87WUFDckIsSUFBSSxFQUFFLElBQUksQ0FBQyxJQUFJO1lBQ2YsSUFBSSxFQUFFLElBQUksQ0FBQyxJQUFJO1NBQ2hCLENBQUE7SUFDSCxDQUFDO0NBQ0Y7QUFoQkQsNEJBZ0JDIn0=